App.BankDetail = DS.Model.extend()
